export interface ScreenBounds {
    left: number;
    top: number;
    right: number;
    bottom: number;
}

export function getViewportScreenBounds(canvas: HTMLCanvasElement, margin = 0): ScreenBounds {
    const width = canvas.clientWidth || canvas.width || 0;
    const height = canvas.clientHeight || canvas.height || 0;
    return {
        left: -margin,
        top: -margin,
        right: width + margin,
        bottom: height + margin,
    };
}

export function isPointVisible(bounds: ScreenBounds, x: number, y: number): boolean {
    return x >= bounds.left && x <= bounds.right && y >= bounds.top && y <= bounds.bottom;
}

export function isRectVisible(
    bounds: ScreenBounds,
    x: number,
    y: number,
    width: number,
    height: number
): boolean {
    return !(x + width < bounds.left || y + height < bounds.top || x > bounds.right || y > bounds.bottom);
}
